import { render, staticRenderFns } from "./LivePage.vue?vue&type=template&id=1b8f0b29&scoped=true"
import script from "./LivePage.vue?vue&type=script&lang=js"
export * from "./LivePage.vue?vue&type=script&lang=js"
import style0 from "./LivePage.vue?vue&type=style&index=0&id=1b8f0b29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f0b29",
  null
  
)

export default component.exports